var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SelectModal", {
    ref: "selectModal",
    attrs: {
      title: _vm.$t("common.contacts.selectModal.title"),
      all: _vm.allContacts,
      selected: _vm.selectedContacts,
      label: _vm.formatContact,
      emptyText: _vm.$t("general.none"),
      showFooterButtons: true
    },
    on: {
      selected: function($event) {
        return _vm.$emit("selected", _vm.selectedContacts)
      },
      add: _vm.onAddContact,
      remove: _vm.onRemoveContact
    },
    scopedSlots: _vm._u([
      {
        key: "footerButtons",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-success mt-2",
                on: { click: _vm.onNewContact }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            ),
            _vm._v(" "),
            _c("ContactEditModal", {
              ref: "editModal",
              attrs: { availableSalutations: _vm.availableSalutations },
              on: { save: _vm.onSave }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }